/**
 * @generated SignedSource<<e6c2ecc3eb4568e4a8b5d9c7691bec2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type KPICreateSubTeamSetNameQuery$variables = {
  teamId: string;
};
export type KPICreateSubTeamSetNameQuery$data = {
  readonly store: {
    readonly team: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
    } | null;
  };
};
export type KPICreateSubTeamSetNameQuery = {
  response: KPICreateSubTeamSetNameQuery$data;
  variables: KPICreateSubTeamSetNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPICreateSubTeamSetNameQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamIconCircleComponent_Team"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPICreateSubTeamSetNameQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0f55f74c9170da6414c702fc58c9dbf0",
    "id": null,
    "metadata": {},
    "name": "KPICreateSubTeamSetNameQuery",
    "operationKind": "query",
    "text": "query KPICreateSubTeamSetNameQuery(\n  $teamId: ID!\n) {\n  store {\n    team(id: $teamId) {\n      id\n      icon\n      color\n      name\n      ...TeamIconCircleComponent_Team\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "c63a6d8d4b517c9a61e015518cbcc3b6";

export default node;
